import React, { useState, useCallback, useMemo, useEffect } from 'react'
import axios from 'axios';
import moment from 'moment/moment';

import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';

import { environment } from '../../env';
import { loaderAction, successModalToggle } from '../../redux/actions/Index';
import Table from './../Table';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { PencilLine } from '@phosphor-icons/react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


function TenantGalaModal({ updateListHandler, ...props}) {

    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const onBasis = useSelector((state) => state?.ModalReducer?.onBasisData);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);

    const [modal, setModal] = useState(false);
    const [btndis, setBtndis] = useState(false);
    const [extend, setExtend] = useState(false);
    const [auto, setAuto] = useState(true)
    const [filteredproposal, setFilteredProposal] = useState({});
    const [proposallist, setProposal] = useState();
    const [annaulrent, setAnnualrent] = useState();
    const [rentt, setRent] = useState(0);
    const [maintenance, setMaintenance] = useState(0);
    const [varai, setVarai] = useState(0);
    const [other_charges, setOther_charges] = useState(0);
    const [extra_amenities, setExtra_amenities] = useState(0);
    const [yearsBetween, setYearsBetween] = useState(0);
    const [monthsBetween, setMonthsBetween] = useState(0);
    const [daysBetween, setDaysBetween] = useState(0);
    const [datasets, setDatasets] = useState();
    const [datas, setData] = useState(false);
    const [edit, setEdit] = useState(false);
    const [possesionerr, setPossesionerr] = useState("");
    const [proposalinvestors, setProposalInvestors] = useState()
    const [ID, setID] = useState(0);
    const [availCheck, setAvailCheck] = useState(false)
    const [rEnd, setRentEnd] = useState()
    const [endAgree, setendAgree] = useState()
    const [rentstartstate, setrentendstate] = useState()
    const [rentendstate, setrentEndstate] = useState()
    const [tabIndex, setTabIndex] = useState(0);
    const [arry, setArr] = useState()
    const [vacatInv, setVacatInv] = useState([])
    const [count, setCount] = useState(0)
    const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()

    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
    } = useForm();
    const {
        register: register2,
        handleSubmit: handleSubmit2,
        watch: watch2,
        setValue: setValue2,
    } = useForm();
    const {
        register: register3,
        handleSubmit: handleSubmit3,
        watch: watch3,
        reset: reset3,
        setValue: setValue3,
        formState: { errors: errors3 },
    } = useForm();
    
    const {
        register: register4,
        handleSubmit: handleSubmit4,
        watch: watch4,
        reset: reset4,
        setValue: setValue4,
        getValues: getValues4,
        formState: { errors: errors4 },
    } = useForm();

    const toggle = () => {
        if (!modal == false) {
            reset();
            reset({
                "rent_free_period": "",
                "rent_start_date": "",
                "rent_end_date": "",
                "rent_actual_start_date": "",
                "rent_actual_end_date": ""
            });
            setDatasets();
            setEdit(false)
            setExtend(false)
            setFilteredProposal({})
            setBtndis(false);
            setAvailCheck(false);
            setYearsBetween(0)
            setMonthsBetween(0)
            setDaysBetween(0)
            setTabIndex(0);
            setArr([])
        }
        setModal(!modal)
    };

    useEffect(() => {
        if (props.button == 'create') {
            setProposal(props.proposalsProp?.filter(data => data.status == 'Approved' && data.agree_created == false && data.project.id == userProject));
        } else {
            setProposal(props.proposalsProp?.filter(data => data.status == 'Approved' && data.agree_created == true && data.project.id == userProject));
        }
    }, [props.proposalsProp])

    const getProposals = async (data) => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}proposal/`).then((proposal) => {
                if (props.button == 'create') {

                    setProposal(proposal.data.filter(data => data.status == 'Approved' && data.agree_created == false && data.project.id == userProject));
                } else {
                    setProposal(proposal.data.filter(data => data.status == 'Approved' && data.agree_created == true && data.project.id == userProject));
                }
                dispatch(loaderAction(false))
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }

    var rentSart = watch("rent_actual_start_date")
    var rentEnd = watch("rent_actual_end_date")
    var aggreement_months = watch("aggreement_months")
    var rent_start_date = watch('rent_start_date')
    var rent_end_date = watch('rent_end_date')

    var rentSart3 = watch3("rent_actual_start_date")
    var rentEnd3 = watch3("rent_actual_end_date")
    var aggreement_months3 = watch3("aggreement_months")
    var terminateStatus = watch2('tarminate_status')
    var rent_end_date_extend = watch3('rent_end_date')
    var rent_start_date3 = watch3('rent_start_date')

    const columnnn = [
        {
            name: 'Investor',
            selector: row => row?.investor.Investors?.name,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Gala No',
            selector: row => Number(row.investor.gala.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area Owns',
            selector: row => (row.investor.sold_gala_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Available',
            selector: row => {
                // if (((row.investor.sold_gala_area - row.investor.rent_area) < row.required_area) && props.button == 'create') {
                //     setAvailCheck(true)
                //     setBtndis(true)
                // }
                return row.investor.sold_gala_area - row.investor.rent_area + " " + "Sq.ft";
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }, {
            name: 'Required Area',
            selector: row => {
                return <>
                    <div className="mt-1  d-flex gap-3">
                        <Label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white">
                            {(row?.required_area) + " " + "Sq.ft"}
                        </Label>
                    </div>
                </>
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ];

    const columnn = [
        {
            name: 'Investor',
            selector: row => row?.investor.Investors?.name,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building',
            selector: row => row?.investor?.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Gala',
            selector: row => Number(row?.investor?.gala?.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rented Area',
            selector: row => (Number(row?.required_area) - Number(row?.vacate_area)) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Vacated',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 " >
                <input
                    type="checkbox"
                    id="invarr"
                    checked={vacatInv?.filter(data => data.id == row.id)[0]?.check}
                    disabled={row?.vacate_area == row?.required_area}
                    className='checkinclusive selectInv'
                    onChange={(e) => { handleArray(e, row) }}>
                </input>
            </div>,
        },
        {
            name: 'Vacated Area',
            selector: row => {
                return <>
                    <div className='mt-1  d-flex gap-3'>
                        <div className="numberTextSuffix w-100">
                            <input
                                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                type='number'
                                name={`area_${row.id}`}
                                min={0}
                                step="any"
                                disabled={!vacatInv?.filter(data => data.id == row.id)[0]?.check}
                                onKeyDown={preventNegativeValues}
                                minLength={0}
                                placeholder={row.vacate_area == 0 ? row.required_area : row.vacate_area}
                                onBlur={(e) => { handleArea(e, row) }}
                            />
                        </div>
                    </div>
                </>
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ];

    useMemo(()=>{
        /**
         * After adding this useMemo the error showing at
         * register('rent_actual_end_date') form is gone.
         */
        console.log("RentEnd Date Changed: ",); 
    },[rentEnd])

    const handleArray = (event, data) => {
        let flag = false
        vacatInv.map(arr => {
            if (arr.id == data.id) {
                flag = true
            }
        })
        if (flag == false) {
            data.remaining_area = Number(data.required_area) - Number(data.vacate_area)
            data.check = true
            if (event?.target?.checked == true) {
                vacatInv.push({ "id": data.id, "required_area": data.required_area, "check": true, "investor": data.investor.Investors.id, "avail": data.remaining_area, "vacate_area": data.remaining_area });
            }
            else if (event.target.checked == false) {
                let currentlength = vacatInv.length;
                for (let i = 0; i < currentlength; i++) {
                    if (data?.id == vacatInv[i]?.id) {
                        vacatInv.splice(i, 1)
                    }
                }
            }
        } else {
            let currentlength = vacatInv.length;
            for (let i = 0; i < currentlength; i++) {
                if (data?.id == vacatInv[i]?.id) {
                    vacatInv.splice(i, 1)
                }
            }
        }

        setCount(count + 1)
    }

    const handleArea = (e, row) => {
        vacatInv.map((data) => {
            if (data.id == row.id) {
                if (data.vacate_area == undefined) {
                    data.vacate_area = Number(e.target.value)
                } else {
                    data.vacate_area = Number(e.target.value)
                }
            }
        })
        setCount(count + 1);
    }

    useMemo(() => {
        setProposalInvestors(proposalinvestors)
    }, [count])

    const onSubmit = async (data) => {
        setBtndis(true)
        if (props.button == 'create') {
            data.project = filteredproposal[0].project.id
            data.building = filteredproposal[0].building_no.id
        }
        else {
            data.project = props.data?.project.id
            data.building = props.data?.building.id

        }
        let a = []
        let re = 0
        let prev_maintenance = 0
        let prev_varai = 0
        let prev_other_charges = 0
        let prev_extra_amenities = 0
        if (props.button == 'create' || extend == true) {
            arry.map(data => {
                data.start_date = moment(data.start_date, "DD/MM/YYYY").format("YYYY-MM-DD")
                data.end_date = moment(data.end_date, "DD/MM/YYYY").format("YYYY-MM-DD")
                data.tenant_rent_start_date = moment(data.tenant_rent_start_date, "DD/MM/YYYY").format("YYYY-MM-DD")
                data.tenant_rent_end_date = moment(data.tenant_rent_end_date, "DD/MM/YYYY").format("YYYY-MM-DD")
                if (data.rent_incrementamt == undefined && data.rent_increment == undefined) {
                    data.rent = re
                }
                if (data.rent_increment == undefined) {
                    data.rent_increment = 0
                }
                if (data.rent_incrementamt == undefined) {
                    data.rent_incrementamt = 0
                }

                if (data.maintenance_increment == undefined && data.maintenance_incrementamt == undefined) {
                    data.maintenance = prev_maintenance
                }
                if(data.maintenance_increment == undefined){
                    data.maintenance_increment = 0
                }
                if(data.maintenance_incrementamt == undefined){
                    data.maintenance_incrementamt = 0
                }

                if (data.varai_increment == undefined && data.varai_incrementamt == undefined) {
                    data.varai = prev_varai
                }
                if(data.varai_increment == undefined){
                    data.varai_increment = 0
                }
                if(data.varai_incrementamt == undefined){
                    data.varai_incrementamt = 0
                }

                if (data.other_charges_increment == undefined && data.other_charges_incrementamt == undefined) {
                    data.other_charges = prev_other_charges
                }
                if(data.other_charges_increment == undefined){
                    data.other_charges_increment = 0
                }
                if(data.other_charges_incrementamt == undefined){
                    data.other_charges_incrementamt = 0
                }

                if (data.extra_amenities_increment == undefined && data.extra_amenities_incrementamt == undefined) {
                    data.extra_amenities = prev_extra_amenities
                }
                if(data.extra_amenities_increment == undefined){
                    data.extra_amenities_increment = 0
                }
                if(data.extra_amenities_incrementamt == undefined){
                    data.extra_amenities_incrementamt = 0
                }

                re = data.rent
                prev_maintenance = data.maintenance
                prev_varai = data.varai
                prev_other_charges = data.other_charges
                prev_extra_amenities = data.extra_amenities

                a.push(data)
            })
        } else {
            let index = 0;
            let prevRent = 0;
            let prevMaintenance = 0;
            let prevVarai = 0;
            let prevOther_charges = 0;
            let prevExtra_amenities = 0;
            annaulrent.map(data => {
                prevRent = Number((Number(data.rent) + Number(prevRent) * (Number(data.rent_increment) / 100)).toFixed(2))
                prevMaintenance = Number((Number(data.maintenance) + Number(prevMaintenance) * (Number(data.maintenance_increment) / 100)).toFixed(2))
                prevVarai = Number((Number(data.varai) + Number(prevVarai) * (Number(data.varai_increment) / 100)).toFixed(2))
                prevOther_charges = Number((Number(data.other_charges) + Number(prevOther_charges) * (Number(data.other_charges_increment) / 100)).toFixed(2))
                prevExtra_amenities = Number((Number(data.extra_amenities) + Number(prevExtra_amenities) * (Number(data.extra_amenities_increment) / 100)).toFixed(2))
                if (index == 0) {
                    a.push({
                        "id":data.id,
                        "start_date": moment(data.start_date).format("YYYY-MM-DD"),
                        "end_date": moment(data.end_date).format("YYYY-MM-DD"),
                        "tenant_rent_start_date" : moment(data.tenant_rent_start_date).format("YYYY-MM-DD"),
                        "tenant_rent_end_date" : moment(data.tenant_rent_end_date).format("YYYY-MM-DD"),
                        "rent": data.rent,
                        "rent_increment": data.rent_increment,
                        "rent_incrementamt": data.rent_incrementamt,
                        "maintenance": data.maintenance,
                        "maintenance_increment": data.maintenance_increment,
                        "maintenance_incrementamt": data.maintenance_incrementamt,
                        "varai": data.varai,
                        "varai_increment": data.varai_increment,
                        "varai_incrementamt": data.varai_incrementamt,
                        "other_charges": data.other_charges,
                        "other_charges_increment": data.other_charges_increment,
                        "other_charges_incrementamt": data.other_charges_incrementamt,
                        "extra_amenities": data.extra_amenities,
                        "extra_amenities_increment": data.extra_amenities_increment,
                        "extra_amenities_incrementamt": data.extra_amenities_incrementamt,
                    })
                } else {
                    a.push({
                        "id":data.id,
                        "srno": index + 1,
                        "start_date": moment(data.start_date).format("YYYY-MM-DD"),
                        "end_date": moment(data.end_date).format("YYYY-MM-DD"),
                        "tenant_rent_start_date" : moment(data.tenant_rent_start_date).format("YYYY-MM-DD"),
                        "tenant_rent_end_date" : moment(data.tenant_rent_end_date).format("YYYY-MM-DD"),
                        "rent": prevRent,
                        "rent_increment": data.rent_increment,
                        "rent_incrementamt": data.rent_incrementamt,
                        "maintenance": data.maintenance,
                        "maintenance_increment": data.maintenance_increment,
                        "maintenance_incrementamt": data.maintenance_incrementamt,
                        "varai": data.varai,
                        "varai_increment": data.varai_increment,
                        "varai_incrementamt": data.varai_incrementamt,
                        "other_charges": data.other_charges,
                        "other_charges_increment": data.other_charges_increment,
                        "other_charges_incrementamt": data.other_charges_incrementamt,
                        "extra_amenities": data.extra_amenities,
                        "extra_amenities_increment": data.extra_amenities_increment,
                        "extra_amenities_incrementamt": data.extra_amenities_incrementamt,
                    })
                }
                index++;
            })
        }
        data.rent_rate = JSON.stringify(a)
        const GalaTenantPayload = new FormData();
        GalaTenantPayload.append('project', data?.project);
        GalaTenantPayload.append('building', data?.building);
        GalaTenantPayload.append('rent_rate', data?.rent_rate);
        GalaTenantPayload.append('proposal', data?.proposal);
        GalaTenantPayload.append('aggrement_start_date', data?.aggrement_start_date);
        GalaTenantPayload.append('aggrement_end_date', data?.aggrement_end_date);
        GalaTenantPayload.append('rent_start_date', data?.rent_start_date);
        GalaTenantPayload.append('rent_end_date', data?.rent_end_date);
        GalaTenantPayload.append('rent_actual_start_date', data?.rent_actual_start_date);
        GalaTenantPayload.append('rent_actual_end_date', data?.rent_actual_end_date);
        GalaTenantPayload.append('possession_date', data?.possession_date);
        GalaTenantPayload.append('rent_free_period', data?.rent_free_period);
        GalaTenantPayload.append('onbasis', data?.onbasis);
        GalaTenantPayload.append('broker_name', data?.broker_name);
        dispatch(loaderAction())
        var URL = ``
        if (props.button == 'create') {
            URL = `${environment.baseUrl}add-gala-tenant/`
        } else if (extend == true) {
            URL = `${environment.baseUrl}extend-tenant/`
        } else {
            URL = `${environment.baseUrl}edit-gala-tenant/${ID}`
        }
        try {
            if (props.button == 'create' || extend == true) {
                await axios.post(URL, GalaTenantPayload).then((form) => {
                    if (form.data.code === 200) {
                        setAuto(!auto);
                        setDatasets();
                        setFilteredProposal({})
                        toggle();
                        reset();
                        reset4();
                        setEdit(false)
                        setAvailCheck(false)
                        dispatch(successModalToggle());
                        setBtndis(false);
                        dispatch(loaderAction());
                        updateListHandler()
                    } else if (form.data.code === 5005) {
                        toast.error('Date Format Error', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }
                })
            } else {
                await axios.put(URL, GalaTenantPayload).then((form) => {
                    if (form.data.code === 200) {
                        setAuto(!auto);
                        setDatasets();
                        setFilteredProposal({})
                        toggle();
                        reset();
                        setEdit(false)
                        setAvailCheck(false)
                        dispatch(successModalToggle());
                        setBtndis(false);
                        dispatch(loaderAction());
                        updateListHandler()
                    } else if (form.data.code === 5005) {
                        toast.error('Date Format Error', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }
                })
            }
        }
        catch (err) {
            setBtndis(false)
            dispatch(loaderAction())
            console.log(err);
            toast.error('Internal Server Error', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
            });
        }
        setTabIndex(0);
    };



    useMemo(() => {
        if (aggreement_months || aggreement_months3) {
            let arr = []
            let rents
            let rente
            let tenant_rent_start_date
            if (extend == false) {
                rents = moment(rentSart)
                rente = moment(rentEnd)
                tenant_rent_start_date = moment(rent_start_date)
            } else if (extend == true) {
                rents = moment(rentSart3)
                rente = moment(rentEnd3)
                tenant_rent_start_date = moment(rent_start_date3)
            }
            setRentEnd(rente.format("DD/MM/YYYY"))
            var datEDiff = rente.diff(rents, "years")
            for (let index = 0; index < datEDiff; index++) {
                if (index == 0) {
                    arr.push({
                        "srno": index + 1,
                        "start_date": rents.format("DD/MM/YYYY"),
                        "end_date": rents.add(1, 'years').add(-1, 'days').format('DD/MM/YYYY'),
                        "tenant_rent_start_date": tenant_rent_start_date?.format('DD/MM/YYYY'),
                        "tenant_rent_end_date": tenant_rent_start_date?.add(1, 'years').add(-1, 'days').format('DD/MM/YYYY'),
                        "rent": rentt,
                        "rent_increment": 0,
                        "rent_incrementamt": 0,
                        "rAmountD": false,
                        "rPercentageD": false,
                        "maintenance": maintenance,
                        "maintenance_increment": 0,
                        "maintenance_incrementamt": 0,
                        "mAmountD": false,
                        "mPercentageD": false,
                        "varai": varai,
                        "varai_increment": 0,
                        "varai_incrementamt": 0,
                        "vAmountD": false,
                        "vPercentageD": false,
                        "other_charges": other_charges,
                        "other_charges_increment": 0,
                        "other_charges_incrementamt": 0,
                        "oAmountD": false,
                        "oPercentageD": false,
                        "extra_amenities": extra_amenities,
                        "extra_amenities_increment": 0,
                        "extra_amenities_incrementamt": 0,
                        "eAmountD": false,
                        "ePercentageD": false,
                    })
                } else {
                    arr.push({
                        "srno": index + 1,
                        "start_date": rents.add(1, 'days').format("DD/MM/YYYY"),
                        "end_date": rents.add(1, 'years').add(-1, 'days').format('DD/MM/YYYY'),
                        "tenant_rent_start_date": tenant_rent_start_date?.add(1,'days').format("DD/MM/YYYY"),
                        "tenant_rent_end_date": tenant_rent_start_date?.add(1, 'years').add(-1, 'days').format('DD/MM/YYYY'),
                        "rent": rentt,
                        "maintenance": maintenance,
                        "varai": varai,
                        "other_charges": other_charges,
                        "extra_amenities": extra_amenities
                    })
                }
            }
            if (arr[arr.length - 1]?.end_date < rEnd || arr[arr.length - 1]?.end_date > rEnd) {
                if(extend){
                    arr.push({
                        "srno": arr[arr.length - 1].srno + 1,
                        "start_date": moment(arr[arr.length - 1].end_date, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY'),
                        "end_date": rEnd,
                        "tenant_rent_start_date": moment(arr[arr.length - 1].tenant_rent_start_date, 'DD/MM/YYYY').add(1, 'years').format('DD/MM/YYYY'),
                        "tenant_rent_end_date": moment(rent_end_date_extend)?.format('DD/MM/YYYY'),   
                        "rent": rentt,
                        "maintenance": maintenance,
                        "varai": varai,
                        "other_charges": other_charges,
                        "extra_amenities": extra_amenities
                    })
                }else{
                    arr.push({
                        "srno": arr[arr.length - 1].srno + 1,
                        "start_date": moment(arr[arr.length - 1].end_date, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY'),
                        "end_date": rEnd,
                        "tenant_rent_start_date": moment(arr[arr.length - 1].tenant_rent_start_date, 'DD/MM/YYYY').add(1, 'years').format('DD/MM/YYYY'),
                        "tenant_rent_end_date": moment(rent_end_date)?.format('DD/MM/YYYY'),   
                        "rent": rentt,
                        "maintenance": maintenance,
                        "varai": varai,
                        "other_charges": other_charges,
                        "extra_amenities": extra_amenities
                    })
                }
            }
            if (datEDiff == 0) {
                arr.push({
                    "srno": 1,
                    "start_date": rents.format("DD/MM/YYYY"),
                    "end_date": rente.format('DD/MM/YYYY'),
                    "tenant_rent_start_date": tenant_rent_start_date?.format('DD/MM/YYYY'),
                    "tenant_rent_end_date": tenant_rent_start_date?.format('DD/MM/YYYY'),
                    "rent": rentt,
                    "rent_increment": 0,
                    "rent_incrementamt": 0,
                    "rAmountD": false,
                    "rPercentageD": false,
                    "maintenance": maintenance,
                    "maintenance_increment": 0,
                    "maintenance_incrementamt": 0,
                    "mAmountD": false,
                    "mPercentageD": false,
                    "varai": varai,
                    "varai_increment": 0,
                    "varai_incrementamt": 0,
                    "vAmountD": false,
                    "vPercentageD": false,
                    "other_charges": other_charges,
                    "other_charges_increment": 0,
                    "other_charges_incrementamt": 0,
                    "oAmountD": false,
                    "oPercentageD": false,
                    "extra_amenities": extra_amenities,
                    "extra_amenities_increment": 0,
                    "extra_amenities_incrementamt": 0,
                    "eAmountD": false,
                    "ePercentageD": false,
                })
            }
            setArr(arr)
        }
        for(let fieldIndex = 1; fieldIndex<= datEDiff; fieldIndex++){
            if(fieldIndex != 1){
                setValue4(`rent_perc_${fieldIndex}`, "");
                setValue4(`rent_amount_${fieldIndex}`, "");
                setValue4(`ment_perc_${fieldIndex}`, "");
                setValue4(`ment_amount_${fieldIndex}`, "");
                setValue4(`extra_ameni_perc_${fieldIndex}`, "");
                setValue4(`extra_ameni_amount_${fieldIndex}`, "");
                setValue4(`varai_perc_${fieldIndex}`, "");
                setValue4(`varai_amount_${fieldIndex}`, "");
                setValue4(`other_charges_perc_${fieldIndex}`, "");
                setValue4(`other_charges_amount_${fieldIndex}`, "");
            }
        }
        
    }, [rentSart, rentEnd, rEnd, aggreement_months, props.button, rentSart3, rentEnd3, aggreement_months3, rent_start_date])


    useEffect(() => {
        if (props.button == 'create') {
            setProposal(props.proposalsProp?.filter(data => data.status == 'Approved' && data.agree_created == false && data.project.id == userProject));
        } else {
            setProposal(props.proposalsProp?.filter(data => data.status == 'Approved' && data.agree_created == true && data.project.id == userProject));
        }
        // getProposals();
    }, [])

    const getProposalInvestors = async (data) => {
        if (data) {
            dispatch(loaderAction(true))
            try {
                await axios.get(`${environment.baseUrl}proposal-investors/${data}`).then((proposal) => {
                    setProposalInvestors(proposal.data);
                    setEdit(true);
                    setAvailCheck(false);
                    setBtndis(false)
                    dispatch(loaderAction(false))
                })
            }
            catch (err) {
                dispatch(loaderAction(false))
                console.log(err);
            }
        }
    }

    const debounce = useCallback(
        _.debounce((_searchVal) => {
            reset({
                "project": _searchVal[0].project?.id,
                "building": _searchVal[0].building_no?.id
            })
        }, 500),
        []
    );

    const Filter = async (e) => {
        if (props.button == 'create') {
            var proposal = proposallist.filter((filterproposal) => filterproposal.id == e.target.value && filterproposal.status == 'Approved');
            setFilteredProposal(proposal)
            debounce(proposal)
            if (e.target.value) {
                await getProposalInvestors(e.target.value)
            }
            setRent(Number(proposal[0]?.rent_price))
            setMaintenance(Number(proposal[0]?.maintenance))
            setVarai(Number(proposal[0]?.varai))
            setOther_charges(Number(proposal[0]?.other_charges))
            setExtra_amenities(Number(proposal[0]?.extra_amenities))
        }
    }

    const dateVal = e => {
        setValue("rent_start_date", e.target.value)
        setValue("rent_actual_start_date", e.target.value)
        setValue("rent_free_period", 0)
        setDatasets(moment(e.target.value).format('YYYY-MM-DD'))
    };

    const dateEndVal = (e, num) => {
        setendAgree(moment(e.target.value).format('YYYY-MM-DD'))
        if (datasets) {
            const currentDate = moment(e.target.value).format('YYYY-MM-DD');
            const CompleteDate = moment(datasets).format('YYYY-MM-DD')
            var date1 = moment(currentDate).add('days', 1);
            var date2 = moment(CompleteDate);
            var days = date1.diff(date2, 'days')
            let years = date1.diff(date2, 'year');
            date2.add(years, 'years');
            let months = date1.diff(date2, 'months');
            date2.add(months, 'months');
            days = date1.diff(date2, 'days');
            date2.add(days, 'days');
            if (e.edit == true) {
                return ({ "nmonths": Number(months + (12 * years)), "years": years, "months": months, "days": days })
            }
            setYearsBetween(years);
            setMonthsBetween(months);
            setDaysBetween(days);
            if (num == 1) {
                if (e.bubbles) {
                    setValue("aggreement_months", Number(months + (12 * years)))
                } else if (e.val) {
                    setValue('aggrement_end_date', e.target.value)
                }
            } else if (num == 3) {
                if (e.bubbles) {
                    setValue3("aggreement_months", Number(months + (12 * years)))
                } else if (e.val) {
                    setValue3('aggrement_end_date', e.target.value)
                }
            }
        }
        if (num == 1) {
            setValue("rent_end_date", e.target.value)
            setValue("rent_actual_end_date", e.target.value)
        } else if (num == 3) {
            setValue3("rent_end_date", e.target.value)
            setValue3("rent_actual_end_date", e.target.value)
        }
    };
    const rentstartdatef = (e, num) => {
        setrentendstate(moment(e.target.value).format('YYYY-MM-DD'))
        if (e.target.value && datasets) {
            const currentDate = moment(e.target.value).format('YYYY-MM-DD');
            const CompleteDate = moment(datasets).format('YYYY-MM-DD')
            var date1 = moment(currentDate);
            var date2 = moment(CompleteDate);
            var days = date1.diff(date2, 'days')
            if (num == 1) {
                setValue("rent_free_period", days)
                setValue("rent_actual_start_date", e.target.value)
            } else {
                setValue3("rent_actual_start_date", e.target.value)
                setValue3("rent_free_period", days)
            }
        }
    };
    const rentenddatef = (e, num) => {
        if (num == 1) {
            setrentEndstate(moment(e.target.value).format('YYYY-MM-DD'))
            setValue("rent_actual_end_date", e.target.value)
        } else if (num == 3) {
            setrentEndstate(moment(e.target.value).format('YYYY-MM-DD'))
            setValue3("rent_actual_end_date", e.target.value)
        }
    }
    const RentFreePeriod = e => {
        let m = datasets;
        if (e.target.value) {
            m = new Date(m);
            m.setDate(m.getDate() + (Number(e.target.value)))
            setValue("rent_start_date", moment(m).format("YYYY-MM-DD"))
            setValue("rent_actual_start_date", moment(m).format("YYYY-MM-DD"))
        }
    };
    const getTenant = (data) => {
        try {
            axios.get(`${environment.baseUrl}tenant-rentannual/${data}`).then(res => {
                res.data.map((data, i) => {
                    data.srno = i + 1;
                })
                setRent(Number(res.data[res.data.length - 1].rent))
                setMaintenance(Number(res.data[res.data.length - 1].maintenance))
                setVarai(Number(res.data[res.data.length - 1].varai))
                setOther_charges(Number(res.data[res.data.length - 1].other_charges))
                setExtra_amenities(Number(res.data[res.data.length - 1].extra_amenities))
                let extraProperties = [];
                if(res?.data?.length>1){
                    let rAmountD = false
                    let rPercentageD = false
                    let mAmountD = false
                    let mPercentageD = false
                    let vAmountD = false
                    let vPercentageD = false
                    let oAmountD = false
                    let oPercentageD = false
                    let eAmountD = false
                    let ePercentageD = false
                    let srno = 1;
                    res.data?.map(item => {
                        extraProperties.push({...item,
                            srno,
                            rAmountD,
                            rPercentageD,
                            mAmountD,
                            mPercentageD,
                            vAmountD,
                            vPercentageD,
                            oAmountD,
                            oPercentageD,
                            eAmountD,
                            ePercentageD,}
                        )
                        srno = srno + 1;
                    })
                    setAnnualrent(extraProperties)
                }
            }).catch(res => {
                setAnnualrent([])
                console.log("error", res);
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const possession_date = e => {
        let m = datasets;
        if (e.target.value) {
            const currentDate = moment(e.target.value).format('YYYY-MM-DD');
            const CompleteDate = moment(datasets).format('YYYY-MM-DD')
            var date1 = moment(currentDate);
            var date2 = moment(CompleteDate);
            var days = date1.diff(date2, 'days')
            if (days < 0) {
                setPossesionerr("Possesion Date must be after Aggreement Date")
            } else {
                setPossesionerr("")
            }
        }
    }

    const aggreementmonths = (e, num) => {
        let m = datasets;
        if (e.target.value) {
            m = new Date(m)
            var newDate = new Date(m.setMonth(m.getMonth() + Number(e.target.value)));
            newDate = newDate.setDate(newDate.getDate() - 1)
            newDate = moment(newDate).format("YYYY-MM-DD")
            dateEndVal({ "target": { "value": newDate }, "val": "agg" }, num)
        }
    }

    const generalFieldDisableHalndler = (value, srno, percentage_property ,amount_property, amount_field = false) => {
        if (props.button == 'create' || extend == true) {
            if (value != 0) {
                arry.map(item => {
                    if (item.srno == srno && value > 0) {
                        item[amount_property] = amount_field ? false : true;
                        item[percentage_property] = amount_field? true : false;
                    }
                })
            } else {
                arry.map(item => {
                    if (item.srno == srno) {
                        item[amount_property] = false;
                        item[percentage_property] = false;
                    }
                })
            }
        }else{
            if (value != 0) {
                annaulrent.map(item => {
                    if (item.srno == srno && value > 0) {
                        item[amount_property] = amount_field ? false : true;
                        item[percentage_property] = amount_field? true : false;
                    }
                })
            } else {
                annaulrent.map(item => {
                    if (item.srno == srno) {
                        item[amount_property] = false;
                        item[percentage_property] = false;
                    }
                })
            }
        }
    }

    const columns = [
        {
            name: 'Sr No',
            selector: row => row?.srno,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Start Date',
            selector: row => row?.start_date,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'End Data',
            selector: row => row?.end_date,
            sortable: true,
            wrap : true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Rent',
            selector: row => row?.rent,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.rent_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="%"
                                        disabled={row.rPercentageD == true}
                                        {...register4(`rent_perc_${row?.srno}`, {
                                            onChange : (e) => {setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'rPercentageD' ,'rAmountD') },
                                            onBlur: (e) => {generalIncrementHandler(Number(e.target.value), row, true, 'rent', 'rent_increment', 'rent_incrementamt')}
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.rent_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="Amount"
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        disabled={row.rAmountD == true}
                                        {...register4(`rent_amount_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, false, 'rent', 'rent_increment', 'rent_incrementamt'),
                                            onChange: (e) => { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'rPercentageD' ,'rAmountD', true) }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ];

    const otherRentColumns = [
        {
            name: 'Sr No',
            selector: row => row?.srno,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Start Date',
            selector: row => row?.tenant_rent_start_date,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'End Data',
            selector: row => row?.tenant_rent_end_date,
            sortable: true,
            wrap : true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Maintaince',
            selector: row => row?.maintenance,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.maintenance_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="%"
                                        disabled={row.mPercentageD == true}
                                        {...register4(`ment_perc_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, true, 'maintenance', 'maintenance_increment', 'maintenance_incrementamt'),
                                            onChange: (e) =>  { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'mPercentageD' ,'mAmountD')  }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.maintenance_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="Amount"
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        disabled={row.mAmountD == true}
                                        {...register4(`ment_amount_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, false, 'maintenance', 'maintenance_increment', 'maintenance_incrementamt'),
                                            onChange: (e) =>  { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'mPercentageD' ,'mAmountD', true) }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Extra Amenities',
            selector: row => row?.extra_amenities,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.extra_amenities_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="%"
                                        disabled={row.ePercentageD == true}
                                        {...register4(`extra_ameni_perc_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, true, 'extra_amenities', 'extra_amenities_increment', 'extra_amenities_incrementamt'),
                                            onChange: (e) =>  { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'ePercentageD' ,'eAmountD') }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.extra_amenities_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="Amount"
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        disabled={row.eAmountD == true}
                                        {...register4(`extra_ameni_amount_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, false, 'extra_amenities', 'extra_amenities_increment', 'extra_amenities_incrementamt'),
                                            onChange: (e) =>  { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'ePercentageD' ,'eAmountD', true) }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Varai',
            selector: row => row?.varai,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.varai_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="%"
                                        disabled={row.vPercentageD == true}
                                        {...register4(`varai_perc_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, true, 'varai', 'varai_increment', 'varai_incrementamt'),
                                            onChange: (e) => { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'vPercentageD' ,'vAmountD') }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.varai_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="Amount"
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        disabled={row.vAmountD == true}
                                        {...register4(`varai_amount_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, false, 'varai', 'varai_increment', 'varai_incrementamt'),
                                            onChange: (e) => { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'vPercentageD' ,'vAmountD', true)}
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Other',
            selector: row => row?.other_charges,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.other_charges_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="%"
                                        disabled={row.oPercentageD == true}
                                        {...register4(`other_charges_perc_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, true, 'other_charges', 'other_charges_increment', 'other_charges_incrementamt'),
                                            onChange: (e) => { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'oPercentageD' ,'oAmountD') }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.other_charges_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder="Amount"
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        disabled={row.oAmountD == true}
                                        {...register4(`other_charges_amount_${row?.srno}`, {
                                            onBlur: (e) => generalIncrementHandler(Number(e.target.value), row, false, 'other_charges', 'other_charges_increment', 'other_charges_incrementamt'),
                                            onChange: (e) => { setValue4(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'oPercentageD' ,'oAmountD', true) }
                                        })}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ];

    const columnss = [
        {
            name: 'Sr No',
            selector: row => row?.srno,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Start Date',
            selector: row => moment(row?.start_date)?.format('DD-MM-YYYY'),
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'End Data',
            selector: row => moment(row?.end_date)?.format('DD-MM-YYYY'),
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Rent',
            selector: row => row?.rent,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row?.rent_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.rent_increment}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, true, 'rent', 'rent_increment', 'rent_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'rPercentageD' ,'rAmountD') }}
                                        disabled={row.rPercentageD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row?.rent_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.rent_incrementamt}
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, false, 'rent', 'rent_increment', 'rent_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'rPercentageD' ,'rAmountD', true) }}
                                        disabled={row.rAmountD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ];

    const OtherRentColumnss = [
        {
            name: 'Sr No',
            selector: row => row?.srno,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Start Date',
            selector: row => moment(row?.tenant_rent_start_date).format('DD-MM-YYYY'),
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'End Data',
            selector: row => moment(row?.tenant_rent_end_date).format('DD-MM-YYYY'),
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Maintaince',
            selector: row => row?.maintenance,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.maintenance_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.maintenance_increment}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, true, 'maintenance', 'maintenance_increment', 'maintenance_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'mPercentageD' ,'mAmountD') }}
                                        disabled={row.mPercentageD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.maintenance_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.maintenance_incrementamt}
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, false, 'maintenance', 'maintenance_increment', 'maintenance_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'mPercentageD' ,'mAmountD', true) }}
                                        disabled={row.mAmountD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Extra Amenities',
            selector: row => row?.extra_amenities,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.extra_amenities_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.extra_amenities_increment}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, true, 'extra_amenities', 'extra_amenities_increment', 'extra_amenities_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'ePercentageD' ,'eAmountD') }}
                                        disabled={row.ePercentageD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.extra_amenities_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.extra_amenities_incrementamt}
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, false, 'extra_amenities', 'extra_amenities_increment', 'extra_amenities_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'ePercentageD' ,'eAmountD', true) }}
                                        disabled={row.eAmountD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Varai',
            selector: row => row?.varai,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.varai_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.varai_increment}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, true, 'varai', 'varai_increment', 'varai_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'vPercentageD' ,'vAmountD') }}
                                        disabled={row.vPercentageD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.varai_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.varai_incrementamt}
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, false, 'varai', 'varai_increment', 'varai_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'vPercentageD' ,'vAmountD', true) }}
                                        disabled={row.vAmountD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Other',
            selector: row => row?.other_charges,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Inc %',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        placeholder={row.other_charges_increment}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row?.other_charges_increment}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, true, 'other_charges', 'other_charges_increment', 'other_charges_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'oPercentageD' ,'oAmountD') }}
                                        disabled={row.oPercentageD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Inc Amt',
            selector: row => {
                return (
                    <>
                        <div className='mt-1  d-flex gap-3'>
                            {
                                row.srno == 1 ?
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        disabled
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        placeholder={row.other_charges_incrementamt}
                                    /> :
                                    <input
                                        className='p-3 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='number'
                                        placeholder={row.other_charges_incrementamt}
                                        step="any"
                                        onKeyDown={preventNegativeValues}
                                        onBlur={(e) => generalIncrementHandler(Number(e.target.value), row, false, 'other_charges', 'other_charges_increment', 'other_charges_incrementamt')}
                                        onChange={(e) => { setValue2(e.target.value); generalFieldDisableHalndler(e.target.value, row.srno, 'oPercentageD' ,'oAmountD', true) }}
                                        disabled={row.oAmountD == true}
                                    />
                            }
                        </div>
                    </>)
            },
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ];

    const generalIncrementHandler = (e, sr, percentageChange ,property, percentageProperty, amountProperty) => {
        let a = []
        let rentAmt = 0
        let flag = false
        let prev_object_data = undefined
        if (props.button == 'create' || extend == true) {
            arry.map(data => a.push(data))
        } else {
            annaulrent.map(data => a.push(data))
        }
        a.map(data => {
            if (flag == true) {
                if (data[percentageProperty] == 0){
                    data[property] = Number((Number(rentAmt) + Number(Number(data[amountProperty]).toFixed(2))))
                }else if (data[amountProperty] == 0){
                    data[property] = Number(Number(rentAmt) + Number(rentAmt) * Number(data[percentageProperty] / 100)).toFixed(2)
                }else{
                    data[property] = prev_object_data[property]
                }
                data[property] = parseFloat(data[property])
                rentAmt = parseFloat(data[property])
            }
            if (sr.srno - 1 == data.srno) {
                rentAmt = Number(data[property])
            }
            if (data.srno == sr.srno) {
                if(percentageChange){
                    data[property] = Number(rentAmt + rentAmt * (e / 100)).toFixed(2)
                    data[percentageProperty] = parseFloat(e)
                    data[amountProperty] = 0;
                }else{
                    data[property] = Number((Number(rentAmt) + Number(e)).toFixed(2))
                    data[percentageProperty] = 0;
                    data[amountProperty] = parseFloat(e)
                }
                data[property] = parseFloat(data[property])
                rentAmt = parseFloat(data[property])
                
                flag = true
            }
            prev_object_data = data;
        })
        if (props.button == 'create' || extend == true) { setArr(a) } else { setAnnualrent(a) }
    }

    const Extend = () => {
        setExtend(true);
        setDatasets(moment(props.data?.aggrement_end_date).format('YYYY-MM-DD'))
        setYearsBetween(0);
        setMonthsBetween(0);
        setDaysBetween(0);
        reset3({
            "aggrement_end_date": '',
            "rent_start_date": props.data?.aggrement_end_date,
            "aggrement_start_date": props.data?.aggrement_end_date,
            "aggreement_months": 0,
            "rent_end_date": '',
            "rent_actual_start_date": props.data?.aggrement_end_date,
            "rent_actual_end_date": '',
            "possession_date": props.data?.possession_date,
            "rent_free_period": 0,
            "proposal": props.data?.proposal.id,
            "project": props.data?.project.id,
            "building": props.data?.building.id,
            "onbasis": props.data?.onbasis.id,
            "broker_name" : props.data?.broker_name == 'null' ? 'NA' : props.data?.broker_name,
        })
    }

    const TerminateSubmit = async (data) => {
        setBtndis(true)
        const GalaTenantPayload = new FormData();
        GalaTenantPayload.append('tenant', ID);
        GalaTenantPayload.append('proposal', props.data?.proposal.id);
        GalaTenantPayload.append('status', data?.tarminate_status);
        GalaTenantPayload.append('terminate_date', data?.terminate_date);
        GalaTenantPayload.append('vacate_date', data?.vacete_date);
        GalaTenantPayload.append('reason', data?.reason_comment);
        if (data?.tarminate_status == 'Partially') {
            GalaTenantPayload.append('vacate_gala', JSON.stringify(vacatInv));
        }
        dispatch(loaderAction())
        try {
            setBtndis(false);
            await axios.post(`${environment.baseUrl}tenant-terminate`, GalaTenantPayload).then((form) => {
                setBtndis(false);
                if (form.data.code === 200) {
                    setAuto(!auto);
                    dispatch(successModalToggle());
                    dispatch(loaderAction());
                    setDatasets();
                    setEdit(false)
                    setFilteredProposal({})
                    toggle();
                    reset();
                    setVacatInv([])
                    setAvailCheck(false)
                    updateListHandler()
                }
            })
        }
        catch (err) {
            setBtndis(false)
            dispatch(loaderAction())
            console.log(err);
        }
        setTabIndex(0);
    };

    const Editt = () => {
        setEdit(true)
        setExtend(false)
        getTenant(props.data?.id)
        setDatasets(props.data?.aggrement_start_date)
        setID(props.data?.id)
        const currentDate = moment(props.data?.aggrement_end_date).format('YYYY-MM-DD');
        const CompleteDate = moment(props.data?.aggrement_start_date).format('YYYY-MM-DD')
        var date1 = moment(currentDate).add('days', 1);
        var date2 = moment(CompleteDate);
        var days = date1.diff(date2, 'days')
        let years = date1.diff(date2, 'year');
        date2.add(years, 'years');
        let months = date1.diff(date2, 'months');
        date2.add(months, 'months');
        days = date1.diff(date2, 'days');
        date2.add(days, 'days');
        if (props.button == 'edit') {
            setYearsBetween(years);
            setMonthsBetween(months);
            setDaysBetween(days);
        }
        reset({
            "aggrement_start_date": props.data?.aggrement_start_date,
            "aggrement_end_date": props.data?.aggrement_end_date,
            "rent_start_date": props.data?.rent_start_date,
            "aggreement_months": Number(months + (12 * years)),
            "rent_end_date": props.data?.rent_end_date,
            "rent_actual_start_date": props.data?.rent_actual_start_date,
            "rent_actual_end_date": props.data?.rent_actual_end_date,
            "possession_date": props.data?.possession_date,
            "rent_free_period": props.data?.rent_free_period,
            "proposal": props.data?.proposal.id,
            "project": props.data?.project.id,
            "building": props.data?.building.id,
            "onbasis": props.data?.onbasis.id,
            "broker_name" : props.data?.broker_name == 'null' ? 'NA' : props.data?.broker_name,
        })
        getProposalInvestors(props.data?.proposal.id)
    }


    return (
        <>
            {props.button == "create" ? (
                <Button onClick={toggle} className='border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4'><span className='fs-3 d-flex gap-3 title-font-600 ps-3 pe-2'>Create Tenant</span></Button>
            ) : (
                <button
                    onClick={() => { toggle(); setData(!datas); Editt() }}
                    className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
            )}
            <Modal className='border-0' isOpen={modal} toggle={toggle} style={{ maxWidth: (arry != undefined && arry?.length != 0) ? "85%" : ""}} size={"xl"} centered  >
                <ModalHeader className='bg-base-color '><span className='title-font-700 fs-36 text-base-white'>{props.button == 'create' ? "Create Tenant" : tabIndex == 0 ? "Update Tenant" : tabIndex == 1 ? "Extend Tenant" : tabIndex == 2 && "Terminate Tenant"}</span></ModalHeader>
                <div className="row">
                    <Tabs selectedIndex={tabIndex} onSelect={(index) =>
                        setTabIndex(index)} className="">
                        {props.button != 'create' &&
                            < div className="d-flex justify-content-center py-3 bg-background-color">
                                <TabList className="d-flex sellGalaTabsMain gap-2  py-2 rounded">
                                    <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700" onClick={() => { Editt() }}>Edit</Tab>
                                    <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700" onClick={() => { Extend() }}>Extend</Tab>
                                    <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700">Terminate</Tab>
                                </TabList>
                            </div>}
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <TabPanel>
                                <ModalBody className='bg-background-color px-5'>
                                    <div className="row align-items-center">
                                        <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Select Proposal *
                                            </Label>
                                            <br />
                                            {props.button == "create" ? <div className='mt-1  d-flex gap-3'>
                                                <select id="proposal" name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    {...register("proposal", { required: true, onChange: (e) => { Filter(e) } })}>
                                                    <option value="">Search Proposal ID</option>
                                                    {proposallist?.map((proposal, i) => {
                                                        return (
                                                            <option value={proposal.id} key={i}>{proposal.id} - {proposal.name_of_company}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div> : <select id="proposal" disabled value={props?.data?.proposal.id} name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                {...register("proposal", { required: true, onChange: (e) => { Filter(e) } })}>
                                                <option value={props?.data?.proposal.id}>{props?.data?.proposal.id} - {props?.data?.proposal.name_of_company}</option>
                                            </select>}
                                            <p className='fs-3'>{availCheck == true && <ErrorComponents error={"Gala area is not available, Can't create agreement"} />}</p>
                                            {errors.proposal_id && <ErrorComponents error={'Investor Name is required *'} />}
                                            <br />
                                        </div>
                                        <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 text-center pb-3 pt-1">
                                            <h2 className="fs-1 title-font-700 text-base-color">Agreement Details</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement Start Date *
                                            </Label>
                                            <br />

                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    placeholder=' AgreementStartdate...'
                                                    {...register("aggrement_start_date",
                                                        {
                                                            required: true
                                                            ,
                                                            onChange: (e) => { dateVal(e) }
                                                        })}
                                                />
                                            </div>
                                            {errors.aggrement_start_date && <ErrorComponents error={'Agreement Start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement End Date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    id="aggreement_end_date"
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    placeholder=' Agreementenddate...'
                                                    {...register("aggrement_end_date", {
                                                        required: true,
                                                        onChange: (e) => { dateEndVal(e, 1) }
                                                    })}
                                                />
                                            </div>
                                            {errors.aggrement_end_date && <ErrorComponents error={' Agreement End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement Months *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <div className='monthTextSuffix w-100'>
                                                    <input
                                                        id="aggreement_end_date"
                                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                        type='number'
                                                        min={0}
                                                        onKeyDown={preventNegativeValues}
                                                        placeholder='Aggreement Months...'
                                                        {...register("aggreement_months", {
                                                            required: true,
                                                            onBlur: e => aggreementmonths(e, 1)
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            {errors.aggrement_end_date && <ErrorComponents error={' Agreement End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0">
                                            <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                                Agreement Duration
                                            </Label>
                                            <div className="mt-1  d-flex gap-3">
                                                <Label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white">
                                                    {`${yearsBetween} years, ${monthsBetween} months, ${daysBetween} days`}
                                                </Label>
                                            </div>
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent Start From *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={extend == false && datasets}
                                                    placeholder='Rent start date...'
                                                    {...register("rent_start_date", {
                                                        required: true,
                                                        onChange: (e) => { rentstartdatef(e, 1) }
                                                    })}
                                                />
                                            </div>
                                            {errors.rent_start_date && <ErrorComponents error={'Rent start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent End *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none bg-white w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    max={endAgree}
                                                    placeholder='Rent End date...'
                                                    {...register("rent_end_date", { required: true, onChange: (e) => { rentenddatef(e, 1) } })}
                                                />
                                            </div>
                                            {errors.rent_end_date && <ErrorComponents error={'Rent End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent Start To Investor *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={rentstartstate}
                                                    placeholder='Rent start Actual date...'
                                                    {...register("rent_actual_start_date", { required: true })}
                                                />
                                            </div>
                                            {errors.rent_actual_start_date && <ErrorComponents error={'Rent Actual start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent End Of Investor *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    max={rentendstate}
                                                    placeholder='Rent Actual End date...'
                                                    {...register("rent_actual_end_date", {
                                                        required: true,
                                                    })}
                                                />
                                            </div>
                                            {errors.rent_actual_end_date && <ErrorComponents error={'Rent Actual End  date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Date of Possession *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    id="possession_date"
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={datasets}
                                                    placeholder='Enter Possession Date...'
                                                    {...register("possession_date", { required: true, onChange: (e) => possession_date(e) })}
                                                />
                                            </div>
                                            {errors.possession_date && <ErrorComponents error={'Possesion Date is required *'} />}
                                            {possesionerr && <ErrorComponents error={possesionerr} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Rent Free Period *
                                            </Label>
                                            <br />
                                            <div className='mt-1 d-flex gap-3'>
                                                <div className='daysTextSuffix w-100'>
                                                    <input
                                                        className='p-3 bg-white  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                        type='number'
                                                        min={0}
                                                        onKeyDown={preventNegativeValues}
                                                        placeholder='Rent Free Period...'
                                                        {...register("rent_free_period", {
                                                            required: true,
                                                            onBlur: (e) => { RentFreePeriod(e) }
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            {errors.rent_free_period && <ErrorComponents error={'Rent Free Period is required'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Deal Basis On *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <select id="onbasis" name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    {...register("onbasis", { required: true })}>
                                                    <option value="">Select Deal Basis on</option>
                                                    {onBasis?.map((onBasis, i) => {
                                                        return (
                                                            <option value={onBasis.id} key={i}>{onBasis.name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            {errors.rent_free_period && <ErrorComponents error={'Deal Basis On is required'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Broker Name *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                            <input
                                                id="broker_name"
                                                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                type='text'
                                                disabled = {extend == true}
                                                placeholder='Borker Name'
                                                {...register("broker_name", {
                                                    required: 'Borker Name is required',
                                                    pattern :  {
                                                        value : /^[A-Za-z\s]+$/i,
                                                        message: 'Broker Name should only contain letters',
                                                    }
                                                    
                                                })}
                                            />
                                            </div>
                                            {errors.broker_name && <ErrorComponents error={errors.broker_name.message} />}
                                            <br />
                                        </div>

                                        {props.button == 'create' ?
                                            <>
                                                {(arry != undefined && arry?.length != 0) &&
                                                    <div className="bg-white px-2 pb-2 rounded-5 shadow-sm">
                                                        <div className="pt-3">
                                                            <h1 className='fs-2 title-font-700 ms-4 my-3 text-dark'>Annual Rent</h1>
                                                            <Table columns={columns} data={arry} />
                                                            <Table columns={otherRentColumns} data={arry} />
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <>
                                                {
                                                    annaulrent?.length != 0 &&
                                                    <div className="bg-white px-2 pb-2 rounded-5 shadow-sm">
                                                        <div className="pt-3">
                                                            <h1 className='fs-2 title-font-700 ms-4 my-3 text-dark'>Annual Rent</h1>
                                                            <Table columns={columnss} data={annaulrent} />
                                                            <Table columns={OtherRentColumnss} data={annaulrent} />
                                                        </div>
                                                    </div>
                                                }
                                            </>}
                                        {edit && <>
                                            <h2 className="fs-2 title-font-700 text-base-color pt-4">Location Mapping</h2>

                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                    Project Name
                                                </Label>
                                                <br />
                                                <div className='mt-1  d-flex gap-3'>
                                                    <select id="project" name="role_type" readOnly disabled className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                        {...register("project")}>
                                                        <option value="">Select Project</option>
                                                        {projectList?.map((project, i) => {
                                                            return (

                                                                <option value={project.id} key={i}>{project.name}</option>
                                                            )
                                                        })};
                                                    </select>
                                                </div>
                                                {errors.project && <ErrorComponents error={'Project Name is required *'} />}
                                                <br />
                                            </div>
                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                    Building No
                                                </Label>
                                                <br />
                                                <div className='mt-1  d-flex gap-3'>
                                                    <select id="building" name="role_type" readOnly disabled className="p-3   border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                        {...register("building")}>
                                                        <option value="">Select Building</option>
                                                        {buildingList?.map((building, i) => {
                                                            return (

                                                                <option value={building.id} key={i}>{building.building_no}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                {errors.building && <ErrorComponents error={'Building No is required *'} />}
                                                <br />
                                            </div>
                                            <div className="col-12 mx-auto pb-3 pt-3 ">
                                                <div>
                                                    <Table columns={columnnn} data={proposalinvestors} />
                                                </div>
                                            </div>
                                        </>}
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={toggle}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>{' '}
                                    <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >{props.button == 'create' ? "Create" : "Save"}</span></Button>
                                </ModalFooter>
                            </TabPanel>
                        </Form>
                        <Form onSubmit={handleSubmit3(onSubmit)}>
                            <TabPanel>
                                <ModalBody className='bg-background-color px-5'>
                                    <div className="row align-items-center">
                                        <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Select Proposal *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <select id="proposal" disabled value={props?.data?.proposal.id} name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    {...register3("proposal", { required: true, onChange: (e) => { Filter(e) } })}>
                                                    <option value={props?.data?.proposal.id}>{props?.data?.proposal.id} - {props?.data?.proposal.name_of_company}</option>
                                                    {/* {proposallist?.map((proposal, i) => {
                                                        return (
                                                            <option value={proposal.id} key={i}>{proposal.id} - {proposal.name_of_company}</option>
                                                        )
                                                    })} */}
                                                </select>
                                            </div>
                                            <p className='fs-3'>{availCheck == true && <ErrorComponents error={"Gala area is not available, Can't create agreement"} />}</p>
                                            {errors3.proposal_id && <ErrorComponents error={'Investor Name is required *'} />}
                                            <br />
                                        </div>
                                        <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 text-center pb-3 pt-1">
                                            <h2 className="fs-1 title-font-700 text-base-color">Extend Tenant</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement Start date *
                                            </Label>
                                            <br />

                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    placeholder=' AgreementStartdate...'
                                                    {...register3("aggrement_start_date",
                                                        {
                                                            required: true, onChange: (e) => { dateVal(e) }
                                                        })}
                                                />
                                            </div>
                                            {errors3.aggrement_start_date && <ErrorComponents error={'Agreement Start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement End Date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    id="aggreement_end_date"
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    placeholder=' Agreementenddate...'
                                                    {...register3("aggrement_end_date", {
                                                        required: true,
                                                        onChange: (e) => { dateEndVal(e, 3) }
                                                    })}
                                                />
                                            </div>
                                            {errors3.aggrement_end_date && <ErrorComponents error={' Agreement End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Agreement Months *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <div className='monthTextSuffix w-100'>
                                                    <input
                                                        id="aggreement_end_date"
                                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                        type='number'
                                                        min={0}
                                                        onKeyDown={preventNegativeValues}
                                                        placeholder='Aggreement Months...'
                                                        {...register3("aggreement_months", {
                                                            required: true,
                                                            onBlur: e => aggreementmonths(e, 3)
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            {errors3.aggrement_end_date && <ErrorComponents error={' Agreement End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0">
                                            <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                                Agreement Duration
                                            </Label>
                                            <div className="mt-1  d-flex gap-3">
                                                <Label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white">
                                                    {`${yearsBetween} years, ${monthsBetween} months, ${daysBetween} days`}
                                                </Label>
                                            </div>
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent start date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={datasets}
                                                    placeholder='Rent start date...'
                                                    {...register3("rent_start_date", {
                                                        required: true,
                                                        onChange: (e) => { rentstartdatef(e, 3) }
                                                    })}
                                                />
                                            </div>
                                            {errors3.rent_start_date && <ErrorComponents error={'Rent start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent End date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none bg-white w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    max={endAgree}
                                                    placeholder='Rent End date...'
                                                    {...register3("rent_end_date", { required: true, onChange: (e) => { rentenddatef(e, 3) } })}
                                                />
                                            </div>
                                            {errors3.rent_end_date && <ErrorComponents error={'Rent End Date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent Actual start date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={rentstartstate}
                                                    placeholder='Rent start Actual date...'
                                                    {...register3("rent_actual_start_date", { required: true })}
                                                />
                                            </div>
                                            {errors3.rent_actual_start_date && <ErrorComponents error={'Rent Actual start date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Rent Actual End date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    max={rentendstate}
                                                    placeholder='Rent Actual End date...'
                                                    {...register3("rent_actual_end_date", {
                                                        required: true,
                                                    })}
                                                />
                                            </div>
                                            {errors3.rent_actual_end_date && <ErrorComponents error={'Rent Actual End  date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Possession Date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    id="possession_date"
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    min={extend == false && datasets}
                                                    placeholder='Enter Possession Date...'
                                                    disabled
                                                    {...register3("possession_date", { required: true })}
                                                />
                                            </div>
                                            {errors3.possession_date && <ErrorComponents error={'Possesion Date is required *'} />}
                                            {possesionerr && <ErrorComponents error={possesionerr} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Rent Free Period *
                                            </Label>
                                            <br />
                                            <div className='mt-1 d-flex gap-3'>
                                                <div className='daysTextSuffix w-100'>
                                                    <input
                                                        className='p-3 bg-white  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                        type='number'
                                                        min={0}
                                                        onKeyDown={preventNegativeValues}
                                                        placeholder='Rent Free Period...'
                                                        {...register3("rent_free_period", {
                                                            required: true,
                                                            onBlur: (e) => { RentFreePeriod(e) }
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            {errors3.rent_free_period && <ErrorComponents error={'Rent Free Period is required'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Deal Basis On *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <select id="onbasis" name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    {...register3("onbasis", { required: true })}>
                                                    <option value="">Select Deal Basis On</option>
                                                    {onBasis?.map((onBasis, i) => {
                                                        return (
                                                            <option value={onBasis.id} key={i}>{onBasis.name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            {errors3.rent_free_period && <ErrorComponents error={'Deal Basis On is required'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Broker Name *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                            <input
                                                id="broker_name"
                                                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                type='text'
                                                disabled = {extend == true}
                                                placeholder='Borker Name'
                                                {...register3("broker_name", {
                                                    required: 'Borker Name is required',
                                                    pattern :  {
                                                        value : /^[A-Za-z\s]+$/i,
                                                        message: 'Broker Name should only contain letters',
                                                    }
                                                    
                                                })}
                                            />
                                            </div>
                                            {errors.broker_name && <ErrorComponents error={errors.broker_name.message} />}
                                            <br />
                                        </div>

                                        {arry?.length != 0 && <div className="bg-white px-2 pb-5 rounded-5 shadow-sm">
                                            <div className="pt-3">
                                                <Table columns={columns} data={arry} />
                                                <Table columns={otherRentColumns} data={arry} />
                                            </div>
                                        </div>}
                                        {edit && <>
                                            <h2 className="fs-2 title-font-700 text-base-color pt-4 ">Location Mapping</h2>

                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                    Project Name
                                                </Label>
                                                <br />
                                                <div className='mt-1  d-flex gap-3'>
                                                    <select id="project" name="role_type" readOnly disabled className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                        {...register3("project")}>
                                                        <option value="">Select Project</option>
                                                        {projectList?.map((project, i) => {
                                                            return (
                                                                <option value={project.id} key={i}>{project.name}</option>
                                                            )
                                                        })};
                                                    </select>
                                                </div>
                                                {errors3.project && <ErrorComponents error={'Project Name is required *'} />}
                                                <br />
                                            </div>
                                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                    Building No
                                                </Label>
                                                <br />
                                                <div className='mt-1  d-flex gap-3'>
                                                    <select id="building" name="role_type" readOnly disabled className="p-3   border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                        {...register3("building")}>
                                                        <option value="">Select Building</option>
                                                        {buildingList?.map((building, i) => {
                                                            return (

                                                                <option value={building.id} key={i}>{building.building_no}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                {errors3.building && <ErrorComponents error={'Building No is required *'} />}
                                                <br />
                                            </div>
                                            <div className="col-12 mx-auto pb-3 pt-3 ">
                                                <div>
                                                    <Table columns={columnnn} data={proposalinvestors} />
                                                </div>
                                            </div>
                                        </>}
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={toggle}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>{' '}
                                    <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >{props.button == 'create' ? "Create" : "Save"}</span></Button>
                                </ModalFooter>
                            </TabPanel>
                        </Form>
                        <Form onSubmit={handleSubmit2(TerminateSubmit)}>
                            <TabPanel>
                                <ModalBody className='bg-background-color px-5'>
                                    <div className="row align-items-center">
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                                Terminate Status *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <select id="onbasis" name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    {...register2("tarminate_status", { required: true })}>
                                                    <option value="">Select Terminate Status</option>
                                                    <option value="Vacated">Vacated</option>
                                                    <option value="Partially">Partially</option>
                                                    <option value="Occupied">Occupied</option>
                                                </select>
                                            </div>
                                            {errors.tarminat_status && <ErrorComponents error={'terminate_status is required'} />}
                                            <br />
                                        </div>
                                        <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 text-center pb-3 pt-1">
                                            <h2 className="fs-1 title-font-700 text-base-color">Terminate Tenant</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Terminate date *
                                            </Label>
                                            <br />

                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    {...register2("terminate_date", { required: true })}
                                                />
                                            </div>
                                            {errors.terminate_date && <ErrorComponents error={'terminate date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Vacated Date *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <input
                                                    id="aggreement_end_date"
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    type='date'
                                                    placeholder=' Agreementenddate...'
                                                    {...register2("vacete_date", { required: true })}
                                                />
                                            </div>
                                            {errors.vacete_date && <ErrorComponents error={' vaceted date is required *'} />}
                                            <br />
                                        </div>
                                        <div className='col-12 mx-auto mx-md-0  pb-3 pt-1'>
                                            <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                Reason *
                                            </Label>
                                            <br />
                                            <div className='mt-1  d-flex gap-3'>
                                                <textarea
                                                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                    placeholder='Enter  Reason...'
                                                    {...register2("reason_comment", { required: true })}
                                                ></textarea>
                                            </div>
                                            {errors.reason_comment && <ErrorComponents error={'Reason is required *'} />}
                                            <br />
                                        </div>
                                        {terminateStatus == 'Partially' &&
                                            <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h1 className='mb-5 title-font-bold '>Rented Galas <sub>(Select gala to vacant)</sub></h1>
                                                </div>
                                                <Table columns={columnn} data={proposalinvestors} />
                                            </div>
                                        }
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={toggle}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>{' '}
                                    <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >{props.button == 'create' ? "Create" : "Save"}</span></Button>
                                </ModalFooter>
                            </TabPanel>
                        </Form>
                    </Tabs>
                </div >

            </Modal >
        </>
    )
};


export default TenantGalaModal